export default "__VITE_PUBLIC_ASSET__5460657d__"